import { Icon } from '@hyperfish/fishfood';
import * as React from 'react';

export const Spinner = () => <Icon name="loading" className="animate-spin" />;
